export default __webpack_public_path__ + "static/media/doclist.f4fcfb17.jpg";